export default
function entries(state = {
  blocks: {},
  pressurePoints: [],
  reflection: ''
}, action) {
  switch(action.type) {
    case 'REQUEST_ENTRIES':
      return action.entries;
    case 'UPDATE_BLOCKS':
      return action.entries;
    case 'UPDATE_ENTRIES':
      return action.entries;
    default:
      return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/entries.js